export default class Duration {

	private start: [number, number];
	private end: [number, number];

	constructor() {

		this.start = process.hrtime();
	}

	public getDuration(): number {

		this.end = process.hrtime(this.start);

		return Math.round(this.end[1] / 1000000);
	}
}
